<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p56"><span><a href="#/Contents#rp56">APPLE SQUASH SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>This soup is the perfect autumn offering.</i></span></p>
<p class="make"><span>8 first-course servings</span></p>
<p class="hang"><span>1½ cups chopped onions</span></p>
<p class="hang"><span>2 teaspoons ground cinnamon</span></p>
<p class="hang"><span>¼ teaspoon each: ground ginger, cloves</span></p>
<p class="hang"><span>⅛ teaspoon ground nutmeg</span></p>
<p class="hang"><span>1½ tablespoons margarine or butter</span></p>
<p class="hang"><span>1 large butternut squash, peeled, seeded, cubed (about 2½ pounds)</span></p>
<p class="hang"><span>2 tart cooking apples, peeled, cored, chopped</span></p>
<p class="hang"><span>1⅓ cups apple cider</span></p>
<p class="hang"><span>3 cups Chicken Stock (see <a href="#/Chapter012#p2">p. 2</a>)</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="hang"><span>Spiced Sour Cream (recipe follows)</span></p>
<p class="normalt"><span><b>1.</b> Cook onions and spices in margarine in large saucepan over low heat until onions are very tender and golden, about 20 minutes, stirring frequently; add squash, apples, cider, and stock. Heat to boiling; reduce heat and simmer, covered, until tender, about 25 minutes. Process soup in food processor or blender until smooth; season to taste with salt and pepper. Serve with Spiced Sour Cream.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 155</span></p>
<p class="per1"><span>% calories from fat: 15</span></p>
<p class="per1"><span>Protein (g): 3.3</span></p>
<p class="per1"><span>Carbohydrate (g): 32.6</span></p>
<p class="per1"><span>Fat (g): 2.8</span></p>
<p class="per1"><span>Saturated fat (g): 0.5</span></p>
<p class="per1"><span>Cholesterol (mg): 1.3</span></p>
<p class="per1"><span>Sodium (mg): 48</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 2.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
<p class="normalt" id="p56a"><span><a id="page_43"></a><b>Spiced Sour Cream</b></span></p>
<p class="make1"><span>Makes about 1 cup</span></p>
<p class="hang"><span>½ cup fat-free sour cream</span></p>
<p class="hang"><span>1 teaspoon sugar</span></p>
<p class="hang"><span>½ teaspoon ground cinnamon</span></p>
<p class="hang"><span>⅛ teaspoon ground ginger</span></p>
<p class="hang"><span>1–2 teaspoons lemon juice</span></p>
<p class="normalt"><span><b>1.</b> Combine all ingredients.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0237.vue?2a5fd8e2